import firebaseApp from "../../firebase/credenciales";
import { getFirestore, deleteDoc, collection, doc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function eliminarClientes_Embarque(producto) {
  const coleccionRef = collection(db, "Produccion_clientes_embarque/".replace(/ /g, ""));
  const docuRef = doc(coleccionRef, producto.nombre);
  const eliminado = await deleteDoc(docuRef);

  return eliminado;
}
